<template>
  <b-card no-body>
    <b-card-header>
      <div>
        <b-card-title>Sayfa Öğeleri</b-card-title>
        <small class="text-muted">{{ hint }}</small>
      </div>
      <b-button
        variant="primary"
        size="sm"
        @click="openForm()"
      >
        <FeatherIcon icon="PlusIcon" />
        Yeni Öğe
      </b-button>
    </b-card-header>
    <b-table
      v-if="dataList.length"
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
      small
    >
      <template #cell(item_type)="data">
        <b-badge :variant="types[data.item.item_type] ? types[data.item.item_type].variant : 'secondary'">
          {{ types[data.item.item_type] ? types[data.item.item_type].title : data.item.item_type }}
        </b-badge>
      </template>
      <template #cell(title)="data">
        <template v-if="data.item.item_type === 'sdg'">
          {{ data.item.goal }} · {{ data.item.title || goalTitle(data.item.goal) }}
        </template>
        <template v-else>
          {{ data.item.title }}
        </template>
        <div class="font-small-2 text-muted">
          <span v-if="data.item.image">Görsel ✓</span>
          <span
            v-if="data.item.file"
            class="ml-50"
          >Dosya ✓</span>
        </div>
      </template>
      <template #cell(control)="data">
        <div class="text-right text-nowrap">
          <b-button
            variant="flat-primary"
            size="sm"
            @click="openForm(data.item)"
          >
            <FeatherIcon icon="EditIcon" />
          </b-button>
          <b-button
            variant="flat-danger"
            size="sm"
            @click="removeItem(data.item.id)"
          >
            <FeatherIcon icon="TrashIcon" />
          </b-button>
        </div>
      </template>
    </b-table>
    <b-card-body v-else>
      <p class="text-muted mb-0">
        Henüz öğe eklenmedi.
      </p>
    </b-card-body>

    <b-modal
      v-model="modalShow"
      centered
      size="lg"
      :title="form.id ? 'Öğeyi Düzenle' : 'Yeni Öğe'"
      hide-footer
    >
      <b-form-group label="Öğe Türü">
        <v-select
          v-model="form.item_type"
          :options="typeOptions"
          label="title"
          :reduce="item => item.value"
          :clearable="false"
        />
      </b-form-group>

      <b-form-group
        v-if="form.item_type === 'sdg'"
        label="BM Sürdürülebilir Kalkınma Amacı"
        description="Amacın adı, numarası ve rengi sitede otomatik gösterilir."
      >
        <v-select
          v-model="form.goal"
          :options="sdgs"
          :get-option-label="item => item.goal + ' · ' + item.title"
          :reduce="item => item.goal"
          :clearable="false"
        />
      </b-form-group>

      <b-form-group
        :label="form.item_type === 'sdg' ? 'Başlık (isteğe bağlı)' : 'Başlık'"
        :description="form.item_type === 'sdg' ? 'Boş bırakılırsa amacın resmi adı kullanılır.' : ''"
      >
        <b-form-input
          v-model="form.title"
          placeholder="Başlık"
        />
      </b-form-group>

      <b-form-group
        v-if="form.item_type !== 'sdg'"
        :label="form.item_type === 'document' ? 'Kısa Bilgi' : 'Alt Başlık'"
        :description="form.item_type === 'document' ? 'Örn: 2026 · Türkçe / İngilizce' : ''"
      >
        <b-form-input
          v-model="form.subtitle"
          :placeholder="form.item_type === 'document' ? 'Kısa bilgi' : 'Alt başlık'"
        />
      </b-form-group>

      <b-form-group :label="form.item_type === 'section' ? 'Metin' : (form.item_type === 'sdg' ? 'KPS\'nin Katkısı' : 'Açıklama (isteğe bağlı)')">
        <quill-editor
          v-if="form.item_type === 'section'"
          v-model="form.content"
          :options="editorOption"
          class="bg-white text-black-50"
        >
          <div
            id="item_content_toolbar"
            slot="toolbar"
          >
            <editor-toolbar />
          </div>
        </quill-editor>
        <b-form-textarea
          v-else
          v-model="form.content"
          rows="3"
        />
      </b-form-group>

      <b-row v-if="form.item_type !== 'sdg'">
        <b-col
          cols="12"
          :md="form.item_type === 'document' ? 6 : 12"
        >
          <b-form-group :label="form.item_type === 'document' ? 'Kapak Görseli (isteğe bağlı)' : 'Görsel'">
            <b-img
              v-if="form.image"
              :src="mediaUrl + form.image"
              thumbnail
              class="mb-50"
              style="max-height: 140px"
            />
            <b-form-file
              v-model="imageFile"
              accept="image/jpeg, image/png, image/webp"
              placeholder="Görsel seçin..."
              browse-text="Seç"
            />
            <div class="mt-50">
              <b-button
                variant="primary"
                size="sm"
                :disabled="!imageFile || uploading"
                @click="upload('image')"
              >
                <FeatherIcon icon="UploadIcon" />
                Görsel Yükle
              </b-button>
              <b-button
                v-if="form.image"
                variant="flat-danger"
                size="sm"
                @click="form.image = null"
              >
                Kaldır
              </b-button>
            </div>
          </b-form-group>
        </b-col>
        <b-col
          v-if="form.item_type === 'document'"
          cols="12"
          md="6"
        >
          <b-form-group label="Dosya (PDF)">
            <a
              v-if="form.file"
              :href="mediaUrl + form.file"
              target="_blank"
              class="d-block mb-50"
            >
              <FeatherIcon icon="FileTextIcon" />
              {{ form.file }}
            </a>
            <b-form-file
              v-model="docFile"
              accept="application/pdf"
              placeholder="PDF seçin..."
              browse-text="Seç"
            />
            <div class="mt-50">
              <b-button
                variant="primary"
                size="sm"
                :disabled="!docFile || uploading"
                @click="upload('file')"
              >
                <FeatherIcon icon="UploadIcon" />
                Dosya Yükle
              </b-button>
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group label="Sıra No">
        <b-form-input
          v-model="form.ordering"
          type="number"
          placeholder="Sıra No"
        />
      </b-form-group>

      <b-alert
        v-if="error"
        show
        variant="danger"
      >
        <div class="alert-body">
          {{ error }}
        </div>
      </b-alert>
      <b-button
        variant="primary"
        :disabled="saving || uploading"
        @click="save"
      >
        <FeatherIcon icon="SaveIcon" />
        Kaydet
      </b-button>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BTable, BButton, BBadge, BModal, BFormGroup, BFormInput,
  BFormTextarea, BFormFile, BImg, BRow, BCol, BAlert,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { quillEditor } from 'vue-quill-editor'
import EditorToolbar from '@/layouts/components/common/EditorToolbar.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import sdgs from '@/libs/sdgs'

const emptyForm = () => ({
  id: null,
  item_type: 'section',
  goal: null,
  title: null,
  subtitle: null,
  content: null,
  image: null,
  file: null,
  ordering: null,
})

export default {
  name: 'ContentItems',
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BTable,
    BButton,
    BBadge,
    BModal,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormFile,
    BImg,
    BRow,
    BCol,
    BAlert,
    vSelect,
    quillEditor,
    EditorToolbar,
  },
  data() {
    return {
      sdgs,
      mediaUrl: `${this.$store.state.app.baseURL.replace(/\/+$/, '')}/media/contents/`,
      types: {
        section: { title: 'Bölüm', variant: 'light-primary' },
        sdg: { title: 'BM Amacı', variant: 'light-success' },
        document: { title: 'Belge', variant: 'light-warning' },
      },
      typeOptions: [
        { title: 'Bölüm (görsel + metin)', value: 'section' },
        { title: 'BM Sürdürülebilir Kalkınma Amacı', value: 'sdg' },
        { title: 'Belge (PDF) — katalog, KVKK metni vb.', value: 'document' },
      ],
      fields: [
        { key: 'item_type', label: 'TÜR', thStyle: { width: '110px' } },
        { key: 'title', label: 'BAŞLIK' },
        { key: 'ordering', label: 'SIRA', thStyle: { width: '70px' } },
        { key: 'control', label: '', thStyle: { width: '110px' } },
      ],
      editorOption: {
        modules: {
          toolbar: '#item_content_toolbar',
        },
        theme: 'snow',
      },
      modalShow: false,
      form: emptyForm(),
      imageFile: null,
      docFile: null,
      uploading: false,
      saving: false,
      error: null,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['contents/dataItem']
    },
    dataList() {
      return this.$store.getters['contentItems/dataList']
    },
    // sayfaya göre önerilen öğe türü
    defaultType() {
      return ['yedek-parca', 'kvkk'].includes(this.dataItem.slug) ? 'document' : 'section'
    },
    hint() {
      if (this.dataItem.slug === 'yedek-parca') return 'Kataloglar: "Belge (PDF)" olarak ekleyin.'
      if (this.dataItem.slug === 'kvkk') return 'KVKK metinleri / formlar: "Belge (PDF)" olarak ekleyin.'
      if (this.dataItem.slug === 'surdurulebilirlik') return 'Görsel + metin bölümleri ve BM Sürdürülebilir Kalkınma Amaçları.'
      return 'Bölümler, BM amaçları veya PDF belgeler.'
    },
  },
  watch: {
    'dataItem.id': {
      immediate: true,
      handler(id) {
        if (id) {
          this.getDataList()
        }
      },
    },
  },
  methods: {
    getDataList() {
      this.$store.dispatch('contentItems/getDataList', this.dataItem.id)
    },
    goalTitle(goal) {
      const item = this.sdgs.find(s => s.goal === Number(goal))
      return item ? item.title : ''
    },
    openForm(item) {
      this.form = item
        ? { ...emptyForm(), ...item, goal: item.goal ? Number(item.goal) : null }
        : { ...emptyForm(), item_type: this.defaultType, ordering: this.dataList.length + 1 }
      this.imageFile = null
      this.docFile = null
      this.error = null
      this.modalShow = true
    },
    upload(field) {
      this.uploading = true
      this.$store.dispatch('fileUpload/uploadFile', {
        upload_file: field === 'image' ? this.imageFile : this.docFile,
        folder: 'contents',
      })
        .then(response => {
          if (response && response.filename) {
            this.form[field] = response.filename
            if (field === 'image') this.imageFile = null
            else this.docFile = null
          } else {
            this.error = 'Dosya yüklenemedi. Dosya türünü ve boyutunu kontrol edin.'
          }
        })
        .finally(() => {
          this.uploading = false
        })
    },
    validate() {
      const f = this.form
      if (f.item_type === 'sdg' && !f.goal) return 'Lütfen bir amaç seçin.'
      if (f.item_type !== 'sdg' && !f.title) return 'Lütfen başlık girin.'
      if (f.item_type === 'document' && !f.file) return 'Lütfen PDF dosyasını yükleyin.'
      return null
    },
    save() {
      this.error = this.validate()
      if (this.error) return
      this.saving = true
      this.$store.dispatch('contentItems/saveData', { ...this.form, id_contents: this.dataItem.id })
        .then(res => {
          if (res && res.status) {
            this.modalShow = false
            this.getDataList()
            this.showToast({
              variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: res.message,
            })
          } else {
            this.error = (res && res.message) || 'Kaydedilemedi.'
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
    removeItem(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('contentItems/removeData', id).then(() => this.getDataList())
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: params,
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
